import styled from 'styled-components';

const StyledCaseInfo = styled.div.attrs(() => ({
  className: 'd-flex flex-column justify-content-between align-items-center',
}))`
  position: relative;
  @media screen and (min-width: 768px) {
    width: 624px;
    max-width: 624px;

  }
  & > section {
    flex: 1 1 auto;
    & > img {
      width: 140px;
      margin-bottom: 16px;
    }
    & > h4 {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 16px;
      text-align: center;
      white-space: pre-line;
    }
    & > p {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;
      text-align: center;
      white-space: pre-line;
    }
  }
  & > article {
    flex: 0 1 auto;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    flex-wrap: wrap;
  }
  & > article > * {
    margin: 4px 16px;
  }
  & .optional-close-button {
    position: absolute;
    right: 8px;
    /* bottom: 90%; */
    background-color: transparent;
    border: 0px;
    color: #000000;
    font-weight: bold;
    cursor: pointer;
    bottom: 105%;
    left: 105%;
  }
`;

export default StyledCaseInfo;
